import { render, staticRenderFns } from "./BookScroll.vue?vue&type=template&id=16e30ee6"
import script from "./BookScroll.vue?vue&type=script&lang=js"
export * from "./BookScroll.vue?vue&type=script&lang=js"
import style0 from "./BookScroll.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports